module.exports = __webpack_public_path__ + "static/media/herdy-picking-apples.35d5b714.svg";